import React, { Component } from 'react';
import MediaQuery from 'react-responsive';

import MenuForDesktop from './components/desktop/Menu';
import MenuForMobile from './components/mobile/Menu';
import Separator from './components/Separator';
import Header from './components/Header';
import JOSM from './components/JOSM';
import Tools from './components/Tools';
import DataDumps from './components/DataDumps';
// import AI from './components/AI';
import ContactForDesktop from './components/desktop/Contact';
import ContactForMobile from './components/mobile/Contact';
// import ContestBannerForDesktop from './components/desktop/ContestBanner';
// import ContestBannerForMobile from './components/mobile/ContestBanner';
import './App.css';
import {
  DEVICE_THRESHOLD,
  MENU_HEIGHT,
  HEADER_HEIGHT,
} from './index';

class App extends Component {

  render() {
    return (
      <div className="lp-main-container">
        <MediaQuery minWidth={DEVICE_THRESHOLD + 1}>
          <MenuForDesktop height={MENU_HEIGHT} />
        </MediaQuery>
        <MediaQuery maxWidth={DEVICE_THRESHOLD}>
          <MenuForMobile height={MENU_HEIGHT} />
        </MediaQuery>
        <Header height={HEADER_HEIGHT} topOffset={MENU_HEIGHT} />
        {/* <div className="lp-long-desktop-wrapper">
          <div>
            <MediaQuery minWidth={DEVICE_THRESHOLD + 1}>
              <ContestBannerForDesktop />
            </MediaQuery>
            <MediaQuery maxWidth={DEVICE_THRESHOLD}>
              <ContestBannerForMobile />
            </MediaQuery>
          </div>
        </div> */}
        <JOSM />
        <Separator />
        <Tools />
        <Separator />
        <DataDumps />
        {/* <Separator />
        <AI /> */}
        {/* <div className="lp-short-desktop-wrapper">
          <div>
            <MediaQuery minWidth={DEVICE_THRESHOLD + 1}>
              <ContestBannerForDesktop />
            </MediaQuery>
            <MediaQuery maxWidth={DEVICE_THRESHOLD}>
              <ContestBannerForMobile />
            </MediaQuery>
          </div>
        </div> */}
        <MediaQuery minWidth={DEVICE_THRESHOLD + 1}>
          <ContactForDesktop />
        </MediaQuery>
        <MediaQuery maxWidth={DEVICE_THRESHOLD}>
          <ContactForMobile />
        </MediaQuery>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js